import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CustomizerItemComponent } from './customizer-item/customizer-item';

@Component({
    selector: 'customizer-list',
    templateUrl: 'customizer-list.html',
    styleUrls: ['./customizer-list.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CustomizerItemComponent, CommonModule]
})
export class CustomizerListComponent {
	@Input() items?: Array<any> = [];
	@Input() name: string = 'name';
	@Input() image: (item: any) => string;
	@Input() description: string;
	@Input() discontinued: string;
	@Input() selectedIndex?: number;
	@Input() editMode: boolean;
	@Input() isModelSize: boolean;
	@Input() isGemstone: boolean;
	@Input() scrollPosition: number;
	@Input() variantOrModelIsNew: boolean = false;
	@Output() scrollPositionChange = new EventEmitter<number>();
	@Output() selectedChange = new EventEmitter<number>();
	@Input() noneChoiceTranslation: string;

	@Input() noneChoiceImage: string | null;

	constructor() { }

	setSelected(index: number) {
		this.selectedChange.emit(index);
	}

	updatePosition(pos: any) {
		this.scrollPositionChange.emit(pos);
	}
}
